import { ClosedAccountItem } from '../components/ClosedAccountsSection';
import { useClosedAccountsList } from './useClosedAccountsList';

export function useClosedAccountsSummary(householdID: string): {
  closedAssets: ClosedAccountItem[];
  closedDebts: ClosedAccountItem[];
  isLoading: boolean;
} {
  const { items: closedCash, isLoading: loadingCash } = useClosedAccountsList(householdID, 'CashAccount');
  const { items: closedInvestments, isLoading: loadingInvestments } = useClosedAccountsList(
    householdID,
    'Investment',
  );
  const { items: closedBusiness, isLoading: loadingBusiness } = useClosedAccountsList(householdID, 'Business');
  const { items: closedRealEstate, isLoading: loadingRealEstate } = useClosedAccountsList(householdID, 'RealEstate');
  const { items: closedPPI, isLoading: loadingPPI } = useClosedAccountsList(householdID, 'PersonalPropertyItem');
  const { items: closedNR, isLoading: loadingNR } = useClosedAccountsList(householdID, 'NoteReceivable');
  const { items: closedLoans, isLoading: loadingLoans } = useClosedAccountsList(householdID, 'Loan');

  return {
    closedAssets: [
      ...closedCash,
      ...closedInvestments,
      ...closedBusiness,
      ...closedRealEstate,
      ...closedPPI,
      ...closedNR,
    ],
    closedDebts: closedLoans,
    isLoading:
      loadingCash ||
      loadingInvestments ||
      loadingBusiness ||
      loadingRealEstate ||
      loadingPPI ||
      loadingNR ||
      loadingLoans,
  };
}
